import { BOOKING_URL } from "@/constants";

export const PromoBanner = () => (
  <div className="promo-banner py-4" data-testid="promo-banner">
    <div className="max-w-7xl mx-auto px-4 text-center">
      <p className="text-white font-medium">
        <span className="text-[#D4AF37] font-bold">Book Direct & Save 10%</span>
        {" "}— Become a Best Western Rewards member today!
        <a
          href={BOOKING_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="ml-3 underline hover:text-[#D4AF37]"
        >
          Learn More
        </a>
      </p>
    </div>
  </div>
);
